import React from 'react';
import { withTranslation } from 'react-i18next';
import { RCV } from '../RCV';
import { AccordionStrip } from '../AccordionStrip';
import { SocialBar } from '../SocialBar';
import { QuestionStripBlock, AnswerStripBlock, SocialBarIcons } from './style';
import { connect } from 'react-redux';
import wixService from '../../../../../../services/wixService';

class StripesView extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { questions, settings, design, isDeepLink, styleParams, locale } =
      this.props;
    const isOpenFirstAnswer = isDeepLink
      ? true
      : settings.openFirstAnswer || settings.previewFirstAnswer;

    const isMobile = wixService.isMobile();
    const parentClassAnswer = 'rcvForAnswer';
    const arrQuestions = questions || [];
    const questionHtmlTag =
      styleParams &&
      styleParams.fonts &&
      styleParams.fonts.questionStripesTextFont &&
      styleParams.fonts.questionStripesTextFont.htmlTag
        ? styleParams.fonts.questionStripesTextFont.htmlTag
        : 'h3';
    const questionlistItems = arrQuestions
      .sort((a, b) => a.sortOrder - b.sortOrder)
      .map((faq, index) => {
        const itemIndex = index + 1;
        const questionTitle = faq.question;
        const questionAnswer = faq.answer;
        const questionId = faq.id || itemIndex;
        const categoryId = faq.categoryId;
        const shareLink = faq.shareLink || '';
        const CustomTag = `${questionHtmlTag}`;

        const question_order = faq.sortOrder;
        return {
          title: (
            <QuestionStripBlock
              styleParams={styleParams}
              design={design}
              data-itemProp="name"
              settings={settings}
            >
              <CustomTag id={`title_${itemIndex}`} className="question-title">
                {questionTitle}
              </CustomTag>
            </QuestionStripBlock>
          ),
          className: 'accordion-item',
          dataHook: 'stripMain',
          questionId,
          categoryId,
          itemIndex,
          question_order,
          isOpen: itemIndex === 1 && isOpenFirstAnswer === true,
          children: (
            <div className="answer" data-itemprop="acceptedAnswer">
              <div className={'questionAnswer ' + parentClassAnswer}>
                <AnswerStripBlock
                  styleParams={styleParams}
                  design={design}
                  settings={settings}
                >
                  <RCV
                    locale={locale}
                    content={questionAnswer}
                    isMobile={isMobile}
                    parentClass={parentClassAnswer}
                    textAlignment={settings.textAlignment}
                    isRTL={settings.isRTL}
                    usage="StripesView"
                  />
                </AnswerStripBlock>
              </div>
              <SocialBarIcons design={design} styleParams={styleParams}>
                <SocialBar
                  itemId={questionId}
                  categoryId={categoryId}
                  question_order={question_order}
                  isRTL={settings.isRTL}
                  shareLink={shareLink}
                />
              </SocialBarIcons>
            </div>
          ),
        };
      });

    return (
      <>
        <AccordionStrip
          items={questionlistItems}
          skin={settings.spaces}
          design={design}
          styleParams={styleParams}
          multiple={!settings.openOneAnswer}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(StripesView));
